export const AudienceDetails = {
    server: 'https://doist.us18.list-manage.com',
    user: 'add87d5d9e06cf034200efe61',
    listId: '86269c4ba1',
    defaultSubscribersCount: 160000,
    tags: {
        inspiration: '953222',
        productivityMethods: {
            homepage: '953202',
            blogpost: '2688170',
        },
    },
}
